import React from 'react';

import UserLayout from '../../components/Layout/UserLayout';
import DeleteUser from './deleteUser';

import messages from '../../locale/messages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.deleteAccount);

  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title,
    component: <UserLayout><DeleteUser /></UserLayout>,
  };
}  
